import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import AddOrderPaymentPanel from "@/components/admin/AddOrderPaymentPanel.vue";
import OrderPaymentsListRow from "@/components/admin/OrderPaymentsListRow.vue";
import { computed, inject, onMounted, reactive, watch } from "vue";
import OrderPayment from "@/model/OrderPayment";
import { Formatter } from "@/util/Formatter";
import { PaymentServiceSymbol } from "@/InjectionSymbols";
import { SingularPaymentStatus } from "@/model/enum/SingularPaymentStatus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderPayments',
    props: {
        orderId: { type: Number, required: false }
    },
    emits: ['paymentAdded'],
    setup(__props, { emit: __emit }) {
        const paymentService = inject(PaymentServiceSymbol);
        const props = __props;
        const emit = __emit;
        let payments = reactive([]);
        const paymentSum = computed(() => {
            return payments
                .filter(p => p.status === SingularPaymentStatus.PAID)
                .reduce((previousValue, currentValue) => previousValue + currentValue.amount, 0);
        });
        onMounted(() => {
            if (props.orderId) {
                loadOrderPayments();
            }
        });
        watch(() => props.orderId, () => {
            loadOrderPayments();
        });
        function onPaymentAdded() {
            emit('paymentAdded');
            loadOrderPayments();
        }
        function loadOrderPayments() {
            paymentService?.loadPayments(props.orderId)
                .then(response => {
                payments.length = 0;
                for (let entry of response.data) {
                    const payment = new OrderPayment();
                    payment.assign(entry);
                    payments.push(payment);
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "mt-4" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "text-start d-flex" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "pa-0 font-weight-bold v-col-6" }, {
                                default: _withCtx(() => _cache[0] || (_cache[0] = [
                                    _createTextVNode("Zahlungseingänge")
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_container, { class: "pa-0 font-weight-bold v-col-6 text-end" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(Formatter).currency(paymentSum.value)), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_table, { class: "ma-2" }, {
                        default: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Datum"),
                                    _createElementVNode("th", null, "Höhe"),
                                    _createElementVNode("th", null, "Typ"),
                                    _createElementVNode("th", null, "Status")
                                ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(payments), (payment, index) => {
                                    return (_openBlock(), _createBlock(OrderPaymentsListRow, {
                                        key: index,
                                        payment: payment
                                    }, null, 8, ["payment"]));
                                }), 128))
                            ])
                        ]),
                        _: 1
                    }),
                    (__props.orderId)
                        ? (_openBlock(), _createBlock(AddOrderPaymentPanel, {
                            key: 0,
                            "order-id": __props.orderId,
                            onPaymentAdded: onPaymentAdded
                        }, null, 8, ["order-id"]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
